import { Page } from "@/components/Reveal";
import Hero from "@/sections/Hero";
import Philosophy from "@/sections/Philosophy";
import WhatWeDo from "@/sections/WhatWeDo";
import HowWeWork from "@/sections/HowWeWork";
import Testimonials from "@/sections/Testimonials";
import InsightsSection from "@/sections/InsightsSection";
import FAQSection from "@/components/FAQSection";
import SiteEnd from "@/components/SiteEnd";

export default function Home() {
  return (
    <Page testId="home-page">
      <Hero />
      <Philosophy />
      <WhatWeDo />
      <HowWeWork />
      <Testimonials />
      <FAQSection boxed />
      <InsightsSection />
      <SiteEnd />
    </Page>
  );
}
